module.exports = __webpack_public_path__ + "static/media/slide5-web.233a70f7.jpg";